// import debounce from "lodash/debounce";
// const _validTypes = ["text", "email", "tel", "password", "checkbox", "radio"];

export default {
  props: {
    value: {
      type: String,
      default: "",
      required: true,
    },
    minlength: [String, Number],
    maxlength: [String, Number],
    mask: {
      type: Array[String],
      default: undefined,
    },
    error: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: null,
      required: false,
    },
    type: {
      type: String,
      default: "text",
      // validator: value => _validTypes.includes(value),
    },
    label: {
      type: String,
      default: null,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    listEmail: {
      type: Array,
      required: false,
    },
  },
  computed: {
    hasLabel() {
      return (
        this.label !== null && this.label !== undefined && this.label !== ""
      );
    },
    newEmailList() {
      const prefixEmail = this.value.match(/^[a-z0-9.]+@/i);
      if (!prefixEmail) {
        return [];
      }
      const newEmailList = [];
      this.listEmail.forEach(item => {
        newEmailList.push(prefixEmail[0] + item);
      });
      return newEmailList;
    },
  },
  methods: {
    input(value) {
      this.$emit("input", value);
      this.$emit("keyup", value);
    },
    // input: debounce(function(value) {
    //   this.$emit("input", value);
    // }, 3000),
    blur(value) {
      this.$emit("blur", value);
    },
    keyup(value) {
      this.$emit("keyup", value);
    },
    getError(name) {
      return this.error.status[name];
    },
    filterErrors() {
      const errors = this.error.messages;
      const filteredErrors = errors.filter(error => !this.getError(error.name));
      return filteredErrors;
    },
  },
};
